import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, setSelectedResponsible} from '../OwnershipTransferSlice';
import SelectOptionButton from '../../../Shared/SelectOptionButton/SelectOptionButton';
import {OwnershipTransferStep, EquipmentPaymentObligation} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import ObligationData from '../Shared/ObligationData';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import lightSmallIcon from '../Icons/light-small.svg';
import lightIcon from '../Icons/light.svg';

const Obligations = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
        actionType: DwhActionType.EquipmentChargesPage,
        messageText: DWHMessageText.EquipmentChargesPageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  const [error, setError] = useState(false);
  const [checkbox, setCheckbox] = useState([
    {
      id: 0,
      title: (
        <div className='checkboxes-title ownership-transfer-step'>
          הרוכש והמוכר מבקשים כי הבעלות בציוד שפרטיו רשומים להלן תועבר לרוכש וכל סכום אשר חב המוכר {window.Config.brand_Name_HE} בגין רכישתו, אשר לא יסולק על ידי
          המוכר עד למועד העברת הבעלות, <span className='semi'>יחול מעתה על הרוכש</span>. אי סימון תיבה זו תותיר את החיובים המפורטים לעיל ואת
          הבעלות בציוד בידי המוכר.
        </div>
      ),
      checked: false,
    },
    {
      id: 0,
      title: (
        <div className='checkboxes-title'>
          הרוכש, מעוניין לשלם את יתרת התשלומים בגין מכשיר זה בתשלומים חודשיים ולא בתשלום חד פעמי (כל זאת אם היתרה לא תסולק ע״י המוכר).
        </div>
      ),
      checked: false,
    },
  ]);

  function onCheck(index) {
    let temp = [...checkbox];
    temp[index].checked = !temp[index].checked;
    setCheckbox(temp);
    setError(false);
  }

  const buttons = [
    {
      id: '0',
      label: 'העברת החיוב למנוי',
      value: EquipmentPaymentObligation.Customer,
      selected: props.data.responsibleForNextPayments === EquipmentPaymentObligation.Customer ? true : false,
    },
    {
      id: '1',
      label: 'העברת החיוב לחשבון החברה',
      value: EquipmentPaymentObligation.Organization,
      selected: props.data.responsibleForNextPayments === EquipmentPaymentObligation.Organization ? true : false,
    },
  ];
  const selected_phone = props.data.selectedPhoneNumber?.replace(/^(.{3})(.*)$/, '$1-$2');

  function nextStep() {
    if (props.data.responsibleForNextPayments === EquipmentPaymentObligation.Customer) {
      const checkedCount = checkbox.filter((ch) => ch.checked).length;
      if (checkedCount == checkbox.length) {
        props.setCurrentStep(OwnershipTransferStep.CustomerForm);
      } else {
        setError(true);
      }
    } else {
      props.setCurrentStep(OwnershipTransferStep.CustomerForm);
    }
  }
  function equipmentResponsibilitySelect(data) {
    if (data == EquipmentPaymentObligation.Customer) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
        actionType: DwhActionType.EquipmentChargesPage,
        messageText: DWHMessageText.EquipmentChargesPageYESButtonClicked,
        status: DWHStatus.Ongoing,
      });
    } else {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
        actionType: DwhActionType.EquipmentChargesPage,
        messageText: DWHMessageText.EquipmentChargesPageNOButtonClicked,
        status: DWHStatus.Ongoing,
      });
    }
    setError(false);
    props.setSelectedResponsible(data);
  }
  return (
    <div className='ownership-transfer-obligations'>
      <div className='stepContainer'>
        <div className='image'>
          <Image src={lightIcon} />
        </div>
        <div className='l-title center'>זיהינו שיש למנוי {selected_phone} חיוב על מכשיר</div>
        <div className='m-title center'>בכדי להתקדם בתהליך, יש להעביר את החיובים למנוי או לחשבון החברה</div>
        {props.data.currentEquipmentObligations.map((item, index) => {
          return <ObligationData item={item.currentPayment} key={index} />;
        })}
        <div>
          <SelectOptionButton
            title={'לאן להעביר את החיוב על המכשיר?'}
            buttonsData={buttons}
            onClick={(data) => {
              equipmentResponsibilitySelect(data);
            }}
          />
        </div>

        {props.data.responsibleForNextPayments === EquipmentPaymentObligation.Customer && (
          <div className='checkboxes'>
            <div className='m-title semi'>העברת החיובים בגין הציוד</div>
            <div className='description'>
              <div>
                <Image src={lightSmallIcon} />
              </div>
              <div>סימון תיבות התנאים מטה יוצגו אוטומטית בטופס האישור שישלח למנוי</div>
            </div>
            <div>
              {checkbox.map((item, index) => {
                return (
                  <div className='transfer-checkbox' key={index}>
                    <CheckBox
                      id={index}
                      onCheck={() => onCheck(index)}
                      onUncheck={() => onCheck(index)}
                      checked={item.checked}
                      label={item.title}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className='continue-button'>
          {error && (
            <div className='error center'>
              {props.data.responsibleForNextPayments == EquipmentPaymentObligation.None ? (
                <>כדי להמשיך יש לאשר את העברת החיובים</>
              ) : (
                <>כדי להמשיך יש לבחור לאן להעביר את החיוב</>
              )}
            </div>
          )}
          <BtnSubmit
            className={props.data.responsibleForNextPayments == EquipmentPaymentObligation.None ? 'disabled' : ''}
            onclick={props.data.responsibleForNextPayments != EquipmentPaymentObligation.None ? nextStep : () => setError(true)}
            text={'המשך להזנת פרטי מנוי'}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedResponsible,
};

export default connect(mapStateToProps, mapDispatchToProps)(Obligations);
